import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import BrowserUtils from '../utils/BrowserUtils';
import NBAActionCreator from '../actions/NBAActionCreator';
import StringConstants from '../constants/StringConstants';

const userSettings = '/ibapi/v2/banks/{bank-id}/insights/settings/user';
const getNBAFeedbackEndpoint =
  '/ibapi/v2/banks/{bank-id}/{account_type}/insights?form_factor={form_factor}';
const getSplashEndpoint =
  '/ibapi/v2/banks/{bank-id}/splash/insights?form_factor={form_factor}';

class NBAApiUtils {
  getUserSettingsData() {
    let url = `${envConfig.apiBaseUrlPAAS}${userSettings}`;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.nbaStub.NBAComponent;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.nbaService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        NBAActionCreator.handleNBASetingsSuccess(body);
      },
      (error) => {
        NBAActionCreator.handleNBASetingsError(error);
      }
    );
  }
  getNBAData(accountType) {
    let endpoint = getNBAFeedbackEndpoint.replace(
      '{account_type}',
      accountType
    );
    const device = BrowserUtils.isMobileViewNew() ? 'phone' : 'tablet';
    endpoint = endpoint.replace('{form_factor}', device);
    let url = `${envConfig.apiBaseUrlPAAS}${endpoint}`;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.nbaStub.NBAComponent;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.nbaService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        if (accountType === StringConstants.ACCTSUMM) {
          NBAActionCreator.handleNBADataSuccess(body, status);
        } else if (accountType === StringConstants.PRODUCTPAGE) {
          NBAActionCreator.handleNBAProductDataSuccess(body, status);
        }
      },
      (error, status) => {
        if (accountType === StringConstants.ACCTSUMM) {
          NBAActionCreator.handleNBADataError(error, status);
        } else if (accountType === StringConstants.PRODUCTPAGE) {
          NBAActionCreator.handleNBAProductDataError(error, status);
        }
      }
    );
  }
  getSplashData() {
    const device = BrowserUtils.isMobileViewNew() ? 'phone' : 'tablet';
    const endpoint = getSplashEndpoint.replace('{form_factor}', device);
    let url = `${envConfig.apiBaseUrlPAAS}${endpoint}`;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.nbaStub.NBAComponent;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.nbaService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        NBAActionCreator.handleSplashDataSuccess(body, status);
      },
      (error, status) => {
        NBAActionCreator.handleSplashDataError(error, status);
      }
    );
  }
  setNBAFeedBack(accountType, data, source) {
    let endpoint = getNBAFeedbackEndpoint.replace(
      '{account_type}',
      accountType
    );
    const device = BrowserUtils.isMobileViewNew() ? 'phone' : 'tablet';
    endpoint = endpoint.replace('{form_factor}', device);
    let url = `${envConfig.apiBaseUrlPAAS}${endpoint}`;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.nbaStub.NBAComponent;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.nbaService,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData: data,
      },
      (body, status) => {
        if (source === 'splash') {
          NBAActionCreator.handleSplashSuccess(body, status);
        } else if (source === 'nbacontainer') {
          NBAActionCreator.handleNBAContainerSuccess(body, status);
        }
      },
      (error, status) => {
        if (source === 'splash') {
          NBAActionCreator.handleSplashError(error, status);
        } else if (source === 'nbacontainer') {
          NBAActionCreator.handleNBAContainerError(error, status);
        }
      }
    );
  }
  getResource(path) {
    const request = new XMLHttpRequest();
    if (path) {
      if (path.indexOf('http://') === -1 && path.indexOf('https://') === -1) {
        request.open('GET', window.location.origin + path, false);
      } else {
        request.open('GET', path, false);
      }
      request.send(null);
    }
    if (request.status === 200) {
      return request.responseText;
    } else {
      return '';
    }
  }
}

export default new NBAApiUtils();
